<template> 
    <div>
        <v-dialog v-model="show" max-width="550" overlay-color="#000" overlay-opacity="0.8" :persistent="loading" :transition="phoneOnly ? 'scroll-x-reverse-transition' : 'dialog-transition'" :fullscreen="phoneOnly" :fluid="phoneOnly" scrollable>
            
            <v-card class="pb-1 px-0 overflow-hidden p-relative has-header" :style="`border-radius: ${phoneOnly ? 0 : 8}px!important`" :class="{'fill-height': phoneOnly}">
                <v-progress-linear v-if="loadingSpinner" :active="loadingSpinner" :indeterminate="loadingSpinner" height="1" absolute top color="white"></v-progress-linear>
                <div :style="statusBarOverlay ? `padding-top: ${statusBarInsetPx+10}px; padding-bottom: ${bottomSafeInsetPx+10}px; ` : ''">

                    <v-toolbar flat fixed class="title-bar surface" height="56" style="border-bottom: 1px solid rgba(0,0,0, 0.08)!important">
                            <v-icon color="transparent" class="pa-2">mdi-arrow-left</v-icon>
                            <v-spacer></v-spacer>
                            <div>
                                <!-- <v-icon color="primary" class="me-2">mdi-play-circle</v-icon> -->
                                <strong class="strong-text--text" style="font-size: 1.1rem">{{lecture.name}}</strong>
                            </div>
                            <v-spacer></v-spacer>
                            <div>
                                <slot name="header-actions" />
                                <v-btn v-haptic icon depressed color="white" @click.stop.prevent="show = false" small dark class="primary">
                                    <!-- <v-icon>mdi-close</v-icon> -->
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </div>
                        
                    </v-toolbar>

                    <div v-if="lecture.image_url" class="pa-5">
                        <v-img :src="lecture.image_url" :max-height="pcOnly ? 300 : 220" class="rounded-lg" />
                    </div>
                    <v-tabs v-model="activeTab" color="primary" light grow class="px-0 mx-0 rounded">
                        <v-tab v-haptic href="#videosTab" style="letter-spacing: 0">
                            <v-icon right>mdi-view-list-outline</v-icon>
                            محتويات المحاضرة
                        </v-tab>
                        <v-tab v-haptic href="#descriptionTab" style="letter-spacing: 0">
                            <v-icon right>mdi-text</v-icon>
                            الوصف
                        </v-tab>
                    </v-tabs>
                </div>
                <!-- <v-card-title class="mb-2">
                    <v-icon class="me-2" color="primary">mdi-play-box-multiple-outline</v-icon>
                    الفيديوهات
                </v-card-title> -->
                <!-- <v-card-subtitle></v-card-subtitle> -->
                <v-card-text class="strong-text--text mt-3 px-0" :style="bottomSafeArea ? `padding-bottom: ${bottomSafeInsetPx}px;` : ''">
                    <v-tabs-items v-model="activeTab">
                        <v-tab-item value="videosTab">
                            <!-- <v-alert v-if="!lecture.enable_videos" text dense outlined type="error" icon="mdi-clipboard-text" color="error" class="medium-text font-weight-bold e-link mx-4" v-ripple @click="activeTab = 'examsTab'">
                                لديك امتحانات إجبارية قبل فتح الفيديوهات
                            </v-alert> -->

                            <v-expansion-panels
                                v-if="collections && collections.length"
                                flat
                                class="transparent mb-2"
                            >
                                <v-expansion-panel
                                    v-for="collection in collections"
                                    :key="collection.id"
                                    class="transparent mb-md-3 pa-1 bordered lecture-collection-panel"
                                    :class="{'rounded-lg': pcOnly}"
                                    :style="phoneOnly ? 'border-radius: 0!important;' : ''"
                                >
                                    <v-expansion-panel-header class="px-4 py-2" v-ripple="{class: 'ripple--color'}">
                                        <div class="d-flex align-start">
                                            <div>
                                                <v-icon color="primary" class="me-2">mdi-folder</v-icon>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="strong-text--text text-truncate" style="line-height: 1.5!important;">{{ collection.name }}</div>
                                                <div v-if="collection.items && collection.items.length" class="small-text muted--text">{{ unitFormat(collection.items.length, 'عنصر', 'عنصرين', 'عناصر') }}</div>
                                                <div v-else class="small-text muted--text">فارغ</div>
                                            </div>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="pa-0">
                                        <lecture-contents-list
                                            v-if="collection.items && collection.items.length"
                                            :items="collection.items"
                                            :lecture="lecture"
                                            :opening-exam="openingExam"
                                            hide-attachments
                                            attendance-chip-placement="title"
                                            @play-video="(video, idx) => playVideo(video, idx, collection.items)"
                                            @open-exam="openExam"
                                        />
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <div v-if="items && items.length">
                                <v-subheader style="height: auto!important" class="mt-5">
                                    عناصر أخرى
                                </v-subheader>
                                <lecture-contents-list
                                    :items="items"
                                    :attachments="attachments"
                                    :lecture="lecture"
                                    :opening-exam="openingExam"
                                    attendance-chip-placement="title"
                                    @play-video="playVideo"
                                    @open-exam="openExam"
                                />
                            </div>
                        </v-tab-item>
                        <v-tab-item value="descriptionTab" class="px-6">
                            <div style="line-height: 2.2; white-space: pre-line;" class="medium-text text--text">{{lecture.description}}</div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="phoneDownloadDialog" max-width="400" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="mb-2">حمل تطبيق الهاتف</v-card-title>
                <v-card-subtitle>لكي تتمكن من مشاهدة المحاضرة؛ يجب عليك تحميل تطبيق الهاتف</v-card-subtitle>
                <v-card-text>
                
                    <div class="d-flex justify-center align-center">
                        <store-badge type="playstore" width="150px" />
                        <store-badge type="appstore" width="120px" />
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <video-dialog v-model="showVideoDialog" :video="showVideo" :next="nextVideo" :previous="previousVideo" @playNext="playVideo(nextVideo, nextVideoIndex, videoDialogItemList)" @playPrevious="playVideo(previousVideo, previousVideoIndex, videoDialogItemList)" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import StoreBadge from '../default/store-badge'
import VideoDialog from './video-dialog'
import LectureContentsList from './lecture-contents-list'

export default {
    props: {
        value: {},
        lecture: {},
        videos: {},
        items: {},
        collections: {},
        exams: {},
        attachments: {},
        pay_type: {}
    },
    components: { StoreBadge, VideoDialog, LectureContentsList },
    data(){
        return {
            activeTab: '',
            show: false,
            loading: false,

            phoneDownloadDialog: false,

            showVideoDialog: false,
            showVideo: null,
            nextVideo: null,
            nextVideoIndex: null,

            previousVideo: null,
            previousVideoIndex: null,

            openingExam: false,

            videoDialogItemList: null,
        }
    },
    computed: {
        ...GlobalComputed,
        loadingSpinner(){
            return this.openingExam;
        },
        examsBadge(){
            let count = 0;
            const exams = this.exams ? this.exams : [];
            exams.forEach(exam=>{
                if (exam.needs_attention){
                    count += 1;
                }
            })
            return count;
        },
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        playVideo(video, i, itemList){
            const list = itemList || this.items;
            this.videoDialogItemList = list;
            this.show = false;
            let wpEnabled = this.wpEnabled;

            if (this.platform === 'web' && !wpEnabled && !this.miniDerasaPlatform){
                if (this.pcOnly){
                    const apiToken = window.localStorage.getItem('tK'); // user oauth token
                    const deepLinkProtocol = process.env.VUE_APP_DESKTOP_APP_PROTOCOL;
                    const url = `${deepLinkProtocol}://video?videoId=${video.id}&token=${apiToken}`
                    window.open(url, '_self')
                }else{
                    // on phone, open download-phone-app dialog
                    this.phoneDownloadDialog = true;
                }
            }else if (this.platform === 'android' || this.platform === 'ios' || this.miniDerasaPlatform || wpEnabled){
                window.setTimeout(()=>{
                    this.showVideoDialog = true;
                    this.showVideo = video;

                    this.nextVideo = null;
                    this.nextVideoIndex = null;
                    this.previousVideo = null;
                    this.previousVideoIndex = null;

                    if (list && i + 1 < list.length){
                        const nextItem = list[i + 1];
                        if (nextItem.type === 'video' && !nextItem.locked){
                            this.nextVideo = nextItem.item;
                            this.nextVideoIndex = i + 1;
                        }
                    }
                    if (list && i - 1 >= 0){
                        const previousItem = list[i - 1];
                        if (previousItem.type === 'video' && !previousItem.locked){
                            this.previousVideo = previousItem.item;
                            this.previousVideoIndex = i - 1;
                        }
                    }
                }, 200);
            }
        },

        openExam(exam){
            const exam_code = exam.navigate_to_alternative && exam.alternative_exam ? exam.alternative_exam.exam_code : exam.exam_code;
            // get exam details
            if (!this.openingExam){
                this.openingExam = true;
                window.axios.get(`/exams/details?exam_code=${exam_code}`).then(response=>{
                    this.openingExam = false;
                    this.show = false;
                    const examData = response.data.data;
                    window.setTimeout(()=>{
                        this.$router.push({name: 'exams', params: {examData: examData}, query: {course_id: this.lecture.course_id}})
                    }, 600);

                }).catch(error=>{
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'EXAM_NOT_FOUND'){
                            this.showMsg('الامتحان غير موجود', 'error');
                        }else if (msg === 'EXAM_NOT_STARTED'){
                            this.showMsg('لم يبدأ الامتحان بعد، انتظر حتى يأتي وقت الامتحان', 'error');
                        }else if (msg === 'EXAM_ENDED'){
                            this.showMsg('انتهى الوقت المسموح فيه بدخول الامتحان', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.openingExam = false;
                })
            }
        },
        backButtonHandler(){
            if (this.showVideoDialog){
                this.showVideoDialog = false;

            }else if (this.show){
                this.show = false;
            }else{
                if (this.$route.name === 'course'){
                    this.$router.go(-1);
                }
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    beforeDestroy(){
        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler);
        }
    }
}
</script>

<style lang="scss">
.lecture-collection-panel{
    .v-expansion-panel-content__wrap{
        padding: 0!important;
    }

    &.v-expansion-panel--active:not(:first-child), &.v-expansion-panel--active + .v-expansion-panel{
        margin-top: 0;
    }
}
</style>